<template>
  <div v-title="$route.meta.title">
    <div class="page-heading" style="position:relative;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户标签管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">

        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="标签类型" prop="is_group" key="is_group">
              <el-select v-model="form.is_group" placeholder="请选择" @change="onTagTypeChange" class="width-max" :disabled="id > 0">
                <el-option
                  v-for="item in tag_type_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="标签名称" prop="tagname" key="tagname">
              <el-input v-model="form.tagname">
              </el-input>
            </el-form-item>
            <el-form-item label="是否排他" v-if="form.is_group === '0'" prop="exclusive">
              <el-switch
                  v-model="form.exclusive"
                  active-value="1"
                  inactive-value="0"
              ></el-switch>
            </el-form-item>
            <el-form-item label="标签说明" prop="tagdesc" key="tagdesc">
              <el-input v-model="form.tagdesc">
              </el-input>
            </el-form-item>
            <el-form-item label="关联标签组"
                          prop="belong_group_ids"
                          key="belong_group_ids"
                          v-if="form.is_group === '0'">
              <remote-select
                multiple
                class="width-max"
                clearable
                id-key="id"
                keyword-key="keyword"
                label-key="tagname"
                value-key="id"
                placeholder="请输入标签组名称"
                v-model="form.belong_group_ids"
                :query-request="getUserTagTable"
                :query-params="{is_group: '1'}"
                :find-request="getUserTagDetail">
              </remote-select>
            </el-form-item>

            <el-form-item label="子标签"
                          prop="has_tag_ids"
                          key="has_tag_ids"
                          v-if="form.is_group === '1'">
              <remote-select
                multiple
                class="width-max"
                clearable
                id-key="id"
                keyword-key="keyword"
                label-key="tagname"
                value-key="id"
                placeholder="请输入标签名称"
                v-model="form.has_tag_ids"
                :query-request="getUserTagTable"
                :query-params="{is_group: '0'}"
                :find-request="getUserTagDetail">
              </remote-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary"
                         native-type="submit">提交表单
              </el-button>
              <el-button @click="onReload">重置</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../userTag.rules.js'
// 引入request模块
import request from '@core/api/request'

export default {
  data () {
    return {
      id: 0,
      formRules,
      form: {
        id: 0,
        tagname: '',
        tagdesc: '',
        has_tag_ids: [],
        belong_group_ids: [],
        is_group: '0',
      },
      tag_type_options: [
        {
          value: '0',
          label: '普通标签'
        },
        {
          value: '1',
          label: '标签组'
        }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  methods: {
    ...request.map([
      'getUserTagTable',
      'getUserTagDetail',
    ]),
    onTagTypeChange () {
      // 当标签类型改变时，重置相关字段
      this.form.has_tag_ids = []
      this.form.belong_group_ids = []
      this.form.exclusive = '0'
    },
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getUserTagDetail', {id}).then(({data}) => {
        this.form = data
        if (!this.form.belong_group_ids) {
          this.$set(this.form, 'belong_group_ids', [])
        }
        if (!this.form.has_tag_ids) {
          this.$set(this.form, 'has_tag_ids', [])
        }
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let form = this.form
          this.id ? this.update(this.id, form) : this.create(form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create (form) {
      request.common('createUsertag', form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, this.backToList)
      })
    },
    update (id, form) {
      request.common('updateUsertag', {id, ...form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(this.backToList)
      })
    },
    backToList () {
      this.$router.push({path: '/usertag/table/'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user-tag/pages/UserTagForm.vue